import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import { config } from '../../function/config'
import AdminHeader from './AdminHeader'

export default function AddNewAdmission() {
    const {id} = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)
    const [uploading, setUploading] = useState(false)
    const [departments, setDepartments] = useState([])

    const [selectedFile, setSelectedFile] = useState(null)
    const [openUploadModal, setOpenUploadModal] = useState(false)

    const [formData, setFormData] = useState({
      first_name:'',
      last_name:'',
      age:'',
      dob:'',
      orphan_status:'',
      guardian_details:'',
      address:'',
      remarks:'',
      identification_mark:'',
      gender:'',
      blood_group:'',
      category:'',
    })

    const [errors, setErrors] = useState({
      first_name:'',
      last_name:'',
      age:'',
      dob:'',
      orphan_status:'',
      guardian_details:'',
      address:'',
      remarks:'',
      identification_mark:'',
      gender:'',
      blood_group:'',
      category:'',
    })

    const handleChange = (e) => {
      const { name, value } = e.target

      if (name === 'dob') {
        let calculatedAge = ''

        if (value) {
          const birthDate = new Date(value)
          const today = new Date()

          calculatedAge =
            today.getFullYear() -
            birthDate.getFullYear()

          const monthDifference =
            today.getMonth() - birthDate.getMonth()

          if (
            monthDifference < 0 ||
            (monthDifference === 0 &&
              today.getDate() < birthDate.getDate())
          ) {
            calculatedAge--
          }
        }

        setFormData((prev) => ({
          ...prev,
          dob: value,
          age: calculatedAge
        }))

        // Clear DOB error
        setErrors((prev) => ({
          ...prev,
          dob: ''
        }))

        return
      }

      setFormData((prev) => ({
        ...prev,
        [name]: value
      }))

      // Clear field error when user changes it
      setErrors((prev) => ({
        ...prev,
        [name]: ''
      }))
    }

    const validateForm = () => {
      const newErrors = {}

      if(!formData.first_name.trim()){
        newErrors.first_name = 'First name is required'
      }

      if(!formData.last_name.trim()){
        newErrors.last_name = 'Last name is required'
      }

      if(!formData.age){
        newErrors.age = 'Age is required'
      }

      if(!formData.dob){
        newErrors.dob = 'Date of birth is required'
      }

      if(!formData.orphan_status){
        newErrors.orphan_status = 'First name is required'
      }

      if(formData.orphan_status === 'No' && !formData.guardian_details.trim()){
        newErrors.guardian_details = 'Graduate Details is required'
      }

      if(formData.orphan_status === 'No' && !formData.address.trim()){
        newErrors.address = 'Address is required'
      }

      if(!formData.identification_mark.trim()){
        newErrors.identification_mark = 'Identification Mark is required'
      }

      if(!formData.gender){
        newErrors.gender = 'Please Select Gender'
      }

      if(!formData.blood_group){
        newErrors.blood_group = 'Please Select Blood Group'
      }

      if(!formData.category){
        newErrors.category = 'Please Select Caegory'
      }

      setErrors(newErrors)

      return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async(e) => {
      e.preventDefault()

      const validationErrors = validateForm(formData)

      setErrors(validationErrors)

      if(Object.keys(validationErrors).length > 0){
        return
      }

      setLoading(true)

      try{
        const payload = {
          first_name:formData.first_name,
          last_name:formData.last_name,
          age:formData.age,
          dob:formData.dob,
          orphan_status:formData.orphan_status,
          address:formData.address,
          gender:formData.gender,
          guardian_details:formData.guardian_details,
          remarks:formData.remarks,
          identification_mark:formData.identification_mark,
          blood_group:formData.blood_group,
          category:formData.category
        }

        const res = await axios.post(`${config.baseurl}create_new_admission/`, payload, {
          headers:{
            'Content-Type':'application/json',
            'Authorization':`Token ${token}`
          }
        })

        if(res.status === 200 || res.status === 201){
          toast.success(res.data?.message || 'Staff created successfully')
          setFormData({
            first_name:'',
            last_name:'',
            age:'',
            dob:'',
            orphan_status:'',
            address:'',
            gender:'',
            guardian_details:'',
            remarks:'',
            identification_mark:'',
            blood_group:'',
            category:'',
          })
          setTimeout(() => {
            navigate(-1)
          }, 300)
        }else{
          toast.error(res.data?.message || 'Failed to create staff')
        }
      } catch (error) {
        console.error('Error:', error.response?.data || error)

        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Failed to create branch'

          toast.error(message)
      } finally {
        setLoading(false)
      }
    }

    const closeUploadModal = () => {
      if(uploading){
        return
      }

      setSelectedFile(null)
      setOpenUploadModal(false)
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0">
      <AdminHeader/>

      {/* HEADER */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-6">
        <div className="items-center justify-between text-center">
          <h1 className="mt-1 text-3xl font-bold text-slate-800">
            ADD New Admissions
          </h1>

          <p className="mt-2 text-sm text-slate-500">
            Create a new admissions.
          </p>
        </div>
      </div>

      {/* FORM SECTION */}
      <div className="max-w-7xl mx-auto px-6 pb-12">            
        <div className="mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6 md:p-8">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

              {/* First Name */}
            <div className="md:col-span-2">
              <label
                htmlFor="first_name"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                First Name
                <span className="ml-1 text-red-500">
                    *
                </span>
              </label>

              <input
                id="first_name"
                type="text"
                name="first_name"
                placeholder="Enter first name"
                value={formData.first_name}
                onChange={handleChange}
                className={`${inputClass} ${errors.first_name
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.first_name && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.first_name}</p>
              )}
            </div>

            {/* Last Name */}
            <div className="md:col-span-2">
              <label
                htmlFor="last_name"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Last Name
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <input
                id="last_name"
                type="text"
                name="last_name"
                placeholder="Enter last name"
                value={formData.last_name}
                onChange={handleChange}
                className={`${inputClass} ${errors.last_name
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.last_name && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.last_name}</p>
              )}
            </div>

            {/* Date of Birth */}
            <div className="md:col-span-2">
              <label
                htmlFor="dob"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Date of Birth
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <input
                id="dob"
                type="date"
                name="dob"
                placeholder="Enter Date of Birth"
                value={formData.dob}
                onChange={handleChange}
                className={`${inputClass} ${errors.dob
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.dob && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.dob}</p>
              )}
            </div>

            {/* Age */}
            <div className="md:col-span-2">
              <label
                htmlFor="age"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Age
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <input
                id="age"
                type="number"
                name="age"
                placeholder="Enter Age"
                value={formData.age}
                readOnly
                className={`${inputClass} ${errors.age
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.age && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.age}</p>
              )}
            </div>

            {/* Orphan or Not */}
            <div className="md:col-span-2">
              <label
                htmlFor="orphan_status"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Orphan or Not
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <select
                id="orphan_status"
                name="orphan_status"
                value={formData.orphan_status}
                onChange={handleChange}
                className={`${inputClass} ${errors.orphan_status
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              >
                <option value="">Select Orphan or not</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>

              {errors.orphan_status && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.orphan_status}</p>
              )}
            </div>

            {formData.orphan_status === 'No' && (
              <div>
                {/* Guardian Details */}
                <div className="md:col-span-2">
                  <label
                    htmlFor="first_name"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Guardian Name
                    <span className="ml-1 text-red-500">
                        *
                    </span>
                  </label>

                  <input
                    id="guardian_details"
                    type="text"
                    name="guardian_details"
                    placeholder="Enter first name"
                    value={formData.guardian_details}
                    onChange={handleChange}
                    className={`${inputClass} ${errors.guardian_details
                      ? 'border-red-500 focus:border-red-600'
                      : ''
                    }`}
                  />

                  {errors.guardian_details && (
                    <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.guardian_details}</p>
                  )}
                </div>

                {/* Address */}
                <div className="md:col-span-2">
                  <label
                    htmlFor="address"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Address
                    <span className="ml-1 text-red-500">
                      *
                    </span>
                  </label>

                  <textarea
                    id="address"
                    name="address"
                    rows={4}
                    placeholder="Enter complete branch address"
                    value={formData.address}
                    onChange={handleChange}
                    className={`${inputClass} ${errors.address
                      ? 'border-red-500 focus:border-red-600'
                      : ''
                    }`}
                  />

                  {errors.address && (
                    <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.address}</p>
                  )}
                </div>
              </div>
            )}


            {/* Gender */}
            <div className="md:col-span-2">
                <label
                  htmlFor="gender"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Gender
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.gender
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>

                {errors.gender && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.gender}</p>
                )}
            </div>

            {/* Remarks */}
            <div className="md:col-span-2">
              <label
                htmlFor="remarks"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Remarks
                <span className="ml-1 text-red-500">
                  *
                </span>
              </label>

              <textarea
                id="remarks"
                name="remarks"
                rows={3}
                placeholder="Enter complete branch remarks"
                value={formData.remarks}
                onChange={handleChange}
                className={`${inputClass} ${errors.remarks
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.remarks && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.remarks}</p>
              )}
            </div>

              {/* Identification Mark */}
            <div className="md:col-span-2">
              <label
                htmlFor="identificaion_mark"
                className="mb-2 block text-sm font-semibold text-slate-700"
              >
                Identification Mark
                <span className="ml-1 text-red-500">
                    *
                </span>
              </label>

              <input
                id="identification_mark"
                type="text"
                name="identification_mark"
                placeholder="Enter first name"
                value={formData.identification_mark}
                onChange={handleChange}
                className={`${inputClass} ${errors.identification_mark
                  ? 'border-red-500 focus:border-red-600'
                  : ''
                }`}
              />

              {errors.identification_mark && (
                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.identification_mark}</p>
              )}
            </div>

            {/* Blood Group */}
            <div>
                <label
                  htmlFor="blood_group"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Blood Group
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="blood_group"
                  name="blood_group"
                  value={formData.blood_group}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.blood_group
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>

                {errors.blood_group && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.blood_group}</p>
                )}
            </div>

            {/* Category */}
            <div className="md:col-span-2">
                <label
                  htmlFor="category"
                  className="mb-2 block text-sm font-semibold text-slate-700"
                >
                  Category
                  <span className="ml-1 text-red-500">
                    *
                  </span>
                </label>

                <select
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className={`${inputClass} ${errors.category
                    ? 'border-red-500 focus:border-red-600'
                    : ''
                  }`}
                >
                  <option value="">Select Category</option>
                  <option value="Aged Person">Aged Person</option>
                  <option value="Child">Child</option>
                </select>

                {errors.category && (
                  <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.category}</p>
                )}
            </div>
          </div>

            {/* Form Actions */}
            <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
              <button
                type="button"
                onClick={() => navigate(-1)}
                disabled={loading}
                className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={loading}
                className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  )
}
